const showSuccess = (toaster, text) => {
  if (toaster) {
    // eslint-disable-next-line no-unused-expressions
    toaster?.success(text || 'Código copiado');
  }
};

const fallbackCopyTextToClipboard = (text, toaster) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');

    if (successful) {
      showSuccess(toaster);
    }
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};

// eslint-disable-next-line import/prefer-default-export
export const copyTextToClipboard = (text, toaster) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, toaster);
    return;
  }

  navigator.clipboard.writeText(text).then(
    () => {
      showSuccess(toaster);
    },
    err => {
      console.error('Could not copy text: ', err);
    }
  );
};
